import { Component, OnInit } from '@angular/core';
import { UtilserviceService } from 'app/services/utilservice.service';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-forgotpassword',
  templateUrl: './forgotpassword.component.html',
  styleUrls: ['../login/login.component.scss']
})
export class ForgotpasswordComponent implements OnInit {
  style: any;
  email: string;
  logo: string;
  constructor(private util: UtilserviceService, private toast: ToastrService) { }

  ngOnInit(): void {
    this.style = this.util.getDomainEnviroment().style;
    this.logo = this.util.getDomainEnviroment().landingPageLogo;
  }
  async recoverPassword(){
      await this.util.forgotPassword(this.email);
      this.toast.info("Check your mail box");    
  }
}
